(ns yardwerkz.web.ui.icons
  "Lucide React icon interop helpers."
  (:require
   ["lucide-react" :as lucide]))

(defn icon
  "Render a Lucide icon by name string or keyword.
   Usage: (icon :map-pin {:class \"w-5 h-5\"})
          (icon \"MapPin\" {:class \"w-5 h-5\"})"
  ([icon-name]
   (icon icon-name {}))
  ([icon-name props]
   (let [name-str (if (keyword? icon-name)
                    ;; Convert :map-pin to MapPin (PascalCase)
                    (->> (clojure.string/split (name icon-name) #"-")
                         (map clojure.string/capitalize)
                         (clojure.string/join ""))
                    icon-name)
         component (aget lucide name-str)]
     (when component
       (let [js-props (clj->js (merge {:size 20} props))]
         (.createElement js/React component js-props))))))

;; Pre-resolved icons for hot paths
(def MapPin (.-MapPin lucide))
(def Calendar (.-Calendar lucide))
(def DollarSign (.-DollarSign lucide))
(def CheckCircle (.-CheckCircle lucide))
(def ChevronRight (.-ChevronRight lucide))
(def ChevronLeft (.-ChevronLeft lucide))
(def Shovel (.-Shovel lucide))
(def Trees (.-Trees lucide))
(def Scissors (.-Scissors lucide))
(def Wind (.-Wind lucide))
(def Dog (.-Dog lucide))
(def Mountain (.-Mountain lucide))
(def MapIcon (.-Map lucide))
(def User (.-User lucide))
(def Star (.-Star lucide))
(def Clock (.-Clock lucide))
(def Briefcase (.-Briefcase lucide))
(def PlusCircle (.-PlusCircle lucide))
(def CreditCard (.-CreditCard lucide))
(def X (.-X lucide))
(def Loader (.-Loader lucide))
(def MessageSquare (.-MessageSquare lucide))
(def Bell (.-Bell lucide))
(def Settings (.-Settings lucide))
(def LogOut (.-LogOut lucide))
(def Send (.-Send lucide))
(def Phone (.-Phone lucide))
(def Home (.-Home lucide))
(def Camera (.-Camera lucide))
(def Upload (.-Upload lucide))
(def Undo (.-Undo lucide))
(def Eraser (.-Eraser lucide))
(def Check (.-Check lucide))
(def AlertTriangle (.-AlertTriangle lucide))
(def Flag (.-Flag lucide))
(def Award (.-Award lucide))
(def ThumbsUp (.-ThumbsUp lucide))
(def History (.-History lucide))
(def Shield (.-Shield lucide))
(def Lock (.-Lock lucide))
(def Flower (.-Flower lucide))
(def Image (.-Image lucide))
(def Maximize2 (.-Maximize2 lucide))
(def Zap (.-Zap lucide))
(def Ruler (.-Ruler lucide))
(def Coins (.-Coins lucide))
(def Navigation (.-Navigation lucide))
(def Minus (.-Minus lucide))
(def AlertCircle (.-AlertCircle lucide))
